jQuery(
	function ( $ ) {
		var $button = $( '#whisk-add-recipe-toggle' ),
			$body   = $( 'body' );

		$button.on(
			'click',
			function () {
				tb_show(
					'Add Recipe',
					'/wp-admin/post-new.php?whisk_iframe=true&post_type=whisk_recipe&TB_iframe=true&width=800&height=300'
				);
				window.addEventListener(
					'message',
					function ( event ) {
						tb_remove();
						if ( tinyMCE && tinyMCE.activeEditor ) {
							tinyMCE.activeEditor.insertContent('<div>[whisk-recipe id="' + event.data + '"]</div>', {format: 'raw'});
						}
					}
				);
			}
		);
	}
);

(function( tinymce_ ) {
	if ( tinymce ) {
		tinymce.create(
			'tinymce.plugins.whisk_recipe',
			{
				init : function(ed, url) {
					ed.addButton('dropcap_', {
						title : 'Whisk Recipe',
						cmd : 'insert_recipe',
						image : url.slice( 0, -3 ) + '/images/menu-icon.svg'
					});

					ed.addCommand('insert_recipe', function() {
						var number = prompt("How many posts you want to show ? "),
							shortcode;
						if (number !== null) {
							number = parseInt(number);
							if (number > 0 && number <= 20) {
								shortcode = '[recent-post number="' + number + '"/]';
								ed.execCommand('mceInsertContent', 0, shortcode);
							}
							else {
								alert("The number value is invalid. It should be from 0 to 20.");
							}
						}
					});
				},
			}
		);

		// Register plugin.
		tinymce.PluginManager.add( 'whisk_recipe', tinymce.plugins.whisk_recipe );
	}

})( window.tinymce );
